/**
 * @flow
 */
'use strict';

export const dilationDrugCodes = [
{"code":"0.5% Tropicamide"},
{"code":"1.0% Tropicamide"},
{"code":"0.5% Mydriacyl"},
{"code":"1.0% Mydriacyl"},
{"code":"0.5% Cyclopentolate"},
{"code":"1.0% Cyclopentolate"},
{"code":"2.5% Phenylephrine"}
]

export const dilationEyeCodes = [
{"code":"OD"},
{"code":"OS"},
{"code":"OU"}
]
